// extracted by mini-css-extract-plugin
export var adCheck = "simpleForm-module--ad-check--cb29e";
export var copy = "simpleForm-module--copy--a7b36";
export var form = "simpleForm-module--form--e514b";
export var grid = "simpleForm-module--grid--7162e";
export var headline = "simpleForm-module--headline--2c23d";
export var images = "simpleForm-module--images--cf8f2";
export var logos = "simpleForm-module--logos--ffb26";